<script setup>
import DefaultButton from "@/components/onsiteEditor/components/buttons/DefaultButton.vue";
import BaseModal from '@/components/onsiteEditor/components//modals/BaseModal.vue';

const emit = defineEmits(['closeModal', 'confirm']);

defineProps({
  fullPausedPrice: {
    type: String,
    required: true,
  },
  showVat: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
  <BaseModal
    visible
    class="!tw-max-h-[30rem] !tw-max-w-2xl"
    @close-modal="emit('closeModal')"
  >
    <div
      class="tw-flex tw-min-h-full tw-justify-center"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-space-y-10 tw-py-6">
        <h3 class="tw-text-center tw-text-2xl tw-font-medium tw-leading-10">
          Downgrade account to keep changes made
        </h3>

        <span class="tw-text-center tw-text-base tw-text-slate-300">
          Downgrade your account to keep all the changes you have made so far using the optimizer. By downgrading the
          account you will not be able to make any further changes to your website via the optimizer without upgrading.
        </span>

        <span class="tw-text-center tw-text-base tw-font-bold tw-text-slate-300">
          You will be billed {{ fullPausedPrice }} <span v-if="showVat">(inc. vat)</span> per month by downgrading your website.
        </span>

        <div class="!tw-mt-auto tw-flex tw-space-x-8">
          <DefaultButton
            variant="primary-outline"
            size="large"
            @click="emit('closeModal')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton
            variant="primary"
            size="large"
            @click="emit('confirm')"
          >
            Downgrade
          </DefaultButton>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
